import { render, staticRenderFns } from "./SystemCustomNotificationsSelectUsers.vue?vue&type=template&id=19c834fc&scoped=true"
import script from "./SystemCustomNotificationsSelectUsers.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsSelectUsers.vue?vue&type=script&lang=js"
import style0 from "./SystemCustomNotificationsSelectUsers.vue?vue&type=style&index=0&id=19c834fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c834fc",
  null
  
)

export default component.exports